import { render, staticRenderFns } from "./SaleInvoiceServicePdfDownload.vue?vue&type=template&id=84b505c8&"
import script from "./SaleInvoiceServicePdfDownload.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceServicePdfDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports